// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HERO SECTION */
.hero-section-ct {
  background-image: url("https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/hero-code.webp");
  background-size: cover;
  background-position: center;
}

.hero-img-ct {
  height: 100vh;
  backdrop-filter: blur(1px);
}



.hero-section-ct .hero-text {
  text-align: center;
  color: white;
  font-family: var(--font-family1);
  text-shadow: var(--text-shadow1);
  
  /* A COUPLE HACKS */
  /* 1. move the content of this element to overlay the hero img */
  /* 2. hide the height of this element so there's not extra vertical space */
  transform: translateY(calc(-85vh)); /* the height of the hero img + height of navbar */
  height: 0;
}

.hero-section-ct .hero-text .line1 {
  line-height: 4rem;
  margin: 30px 0;
}

.hero-section-ct .hero-text .line2 {
  padding: 30px 0;
  border: 2px var(--brand-red1) dotted;
  border-left: none;
  border-right: none;
}
.hero-section-ct .hero-text .line2 span {
  color: var(--brand-green1);
}


.hero-section-ct .hero-text .line4 {
  font-weight: bold;
  line-height: 3rem;
  margin: 0;
}
.hero-section-ct .hero-text .line4 a {
  text-decoration: none;
  font-size: 1.8rem;
  padding: 10px;
  color: var(--brand-green1);
  border: 2px var(--brand-red1) dotted;
  border-radius: 10px;
  background-color: transparent;
  font-size: 110%;
  letter-spacing: 3px;
}
.hero-section-ct .hero-text a:hover {
  background-color: var(--btn-green1);
  border: 2px var(--brand-green1) solid;
  color: var(--brand-white1);
}

.hero-section-ct .hero-text .line1 {font-size: 5rem;}
.hero-section-ct .hero-text .line2 {font-size: 3rem;}
.hero-section-ct .hero-text .line3 {font-size: 3rem;}
.hero-section-ct .hero-text .line4 {font-size: 3rem;}
.hero-section-ct .hero-text a {font-size: 3rem;}


@media (max-width: 1030px) {
  .hero-section-ct .hero-text .line1 {font-size: 4rem;}
  .hero-section-ct .hero-text .line2 {font-size: 2rem;}
  .hero-section-ct .hero-text .line3 {font-size: 2rem;}
  .hero-section-ct .hero-text .line4 {font-size: 2rem;}
  .hero-section-ct .hero-text a {font-size: 2rem;}
}


@media (max-width: 445px) {
  .hero-section-ct .hero-text .line1 {font-size: 3rem;}
  .hero-section-ct .hero-text .line2 {font-size: 1.8rem;}
  .hero-section-ct .hero-text .line3 {font-size: 1.8rem;}
  .hero-section-ct .hero-text .line4 {font-size: 1.8rem;}
  .hero-section-ct .hero-text a {font-size: 1.8rem;}
}


@media (max-width: 325px) {
  .hero-section-ct .hero-text .line1 {font-size: 2.5rem;}
  .hero-section-ct .hero-text .line2 {font-size: 1.3rem;}
  .hero-section-ct .hero-text .line3 {font-size: 1.3rem;}
  .hero-section-ct .hero-text .line4 {font-size: 1.3rem;}
  .hero-section-ct .hero-text a {font-size: 1.3rem;}
}



/* Landscape */
@media (max-height: 560px) {
  .line4 {
    display: none;
  }
}
@media (max-height: 445px) {
  .line3 {
    display: none;
  }
}
@media (max-height: 395px) {
  .line2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/hero.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,+HAA+H;EAC/H,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;;;AAIA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;;EAEhC,mBAAmB;EACnB,gEAAgE;EAChE,2EAA2E;EAC3E,kCAAkC,EAAE,kDAAkD;EACtF,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,oCAAoC,eAAe,CAAC;AACpD,oCAAoC,eAAe,CAAC;AACpD,oCAAoC,eAAe,CAAC;AACpD,oCAAoC,eAAe,CAAC;AACpD,+BAA+B,eAAe,CAAC;;;AAG/C;EACE,oCAAoC,eAAe,CAAC;EACpD,oCAAoC,eAAe,CAAC;EACpD,oCAAoC,eAAe,CAAC;EACpD,oCAAoC,eAAe,CAAC;EACpD,+BAA+B,eAAe,CAAC;AACjD;;;AAGA;EACE,oCAAoC,eAAe,CAAC;EACpD,oCAAoC,iBAAiB,CAAC;EACtD,oCAAoC,iBAAiB,CAAC;EACtD,oCAAoC,iBAAiB,CAAC;EACtD,+BAA+B,iBAAiB,CAAC;AACnD;;;AAGA;EACE,oCAAoC,iBAAiB,CAAC;EACtD,oCAAoC,iBAAiB,CAAC;EACtD,oCAAoC,iBAAiB,CAAC;EACtD,oCAAoC,iBAAiB,CAAC;EACtD,+BAA+B,iBAAiB,CAAC;AACnD;;;;AAIA,cAAc;AACd;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* HERO SECTION */\n.hero-section-ct {\n  background-image: url(\"https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/hero-code.webp\");\n  background-size: cover;\n  background-position: center;\n}\n\n.hero-img-ct {\n  height: 100vh;\n  backdrop-filter: blur(1px);\n}\n\n\n\n.hero-section-ct .hero-text {\n  text-align: center;\n  color: white;\n  font-family: var(--font-family1);\n  text-shadow: var(--text-shadow1);\n  \n  /* A COUPLE HACKS */\n  /* 1. move the content of this element to overlay the hero img */\n  /* 2. hide the height of this element so there's not extra vertical space */\n  transform: translateY(calc(-85vh)); /* the height of the hero img + height of navbar */\n  height: 0;\n}\n\n.hero-section-ct .hero-text .line1 {\n  line-height: 4rem;\n  margin: 30px 0;\n}\n\n.hero-section-ct .hero-text .line2 {\n  padding: 30px 0;\n  border: 2px var(--brand-red1) dotted;\n  border-left: none;\n  border-right: none;\n}\n.hero-section-ct .hero-text .line2 span {\n  color: var(--brand-green1);\n}\n\n\n.hero-section-ct .hero-text .line4 {\n  font-weight: bold;\n  line-height: 3rem;\n  margin: 0;\n}\n.hero-section-ct .hero-text .line4 a {\n  text-decoration: none;\n  font-size: 1.8rem;\n  padding: 10px;\n  color: var(--brand-green1);\n  border: 2px var(--brand-red1) dotted;\n  border-radius: 10px;\n  background-color: transparent;\n  font-size: 110%;\n  letter-spacing: 3px;\n}\n.hero-section-ct .hero-text a:hover {\n  background-color: var(--btn-green1);\n  border: 2px var(--brand-green1) solid;\n  color: var(--brand-white1);\n}\n\n.hero-section-ct .hero-text .line1 {font-size: 5rem;}\n.hero-section-ct .hero-text .line2 {font-size: 3rem;}\n.hero-section-ct .hero-text .line3 {font-size: 3rem;}\n.hero-section-ct .hero-text .line4 {font-size: 3rem;}\n.hero-section-ct .hero-text a {font-size: 3rem;}\n\n\n@media (max-width: 1030px) {\n  .hero-section-ct .hero-text .line1 {font-size: 4rem;}\n  .hero-section-ct .hero-text .line2 {font-size: 2rem;}\n  .hero-section-ct .hero-text .line3 {font-size: 2rem;}\n  .hero-section-ct .hero-text .line4 {font-size: 2rem;}\n  .hero-section-ct .hero-text a {font-size: 2rem;}\n}\n\n\n@media (max-width: 445px) {\n  .hero-section-ct .hero-text .line1 {font-size: 3rem;}\n  .hero-section-ct .hero-text .line2 {font-size: 1.8rem;}\n  .hero-section-ct .hero-text .line3 {font-size: 1.8rem;}\n  .hero-section-ct .hero-text .line4 {font-size: 1.8rem;}\n  .hero-section-ct .hero-text a {font-size: 1.8rem;}\n}\n\n\n@media (max-width: 325px) {\n  .hero-section-ct .hero-text .line1 {font-size: 2.5rem;}\n  .hero-section-ct .hero-text .line2 {font-size: 1.3rem;}\n  .hero-section-ct .hero-text .line3 {font-size: 1.3rem;}\n  .hero-section-ct .hero-text .line4 {font-size: 1.3rem;}\n  .hero-section-ct .hero-text a {font-size: 1.3rem;}\n}\n\n\n\n/* Landscape */\n@media (max-height: 560px) {\n  .line4 {\n    display: none;\n  }\n}\n@media (max-height: 445px) {\n  .line3 {\n    display: none;\n  }\n}\n@media (max-height: 395px) {\n  .line2 {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
